import { render } from "./Workplace_Left.vue?vue&type=template&id=a2aa3d50"
import script from "./Workplace_Left.vue?vue&type=script&lang=js"
export * from "./Workplace_Left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__